import React, { useState, useEffect, useCallback } from 'react';
import negocioCallService         from '../services/negocioCall.service';
import negocioEventoService        from '../services/negocioEvento.service';
import timelineTecnicaService      from '../services/timelineTecnica.service';
import clienteParticipanteService  from '../services/clienteParticipante.service';
import AnotacaoModal               from './AnotacaoModal';
import Modal                       from './Modal';
import LancamentoModal             from '../pages/LancamentosHoras/LancamentoModal';

const COR = {
  azul:     '#003399',
  azulBg:   '#eff6ff',
  borda:    '#e8eaed',
  texto:    '#1a1a2e',
  muted:    '#888',
  branco:   '#fff',
  verde:    '#1D9E75',
  verdeBg:  '#f0fff4',
  vermelho: '#e53935',
  vermBg:   '#fff0f0',
  amarelo:  '#d97706',
  amlBg:    '#fffbeb',
  cinzaBg:  '#fafafa',
  teams:    '#6264a7',
};

const inputStyle = {
  width: '100%', height: '36px', padding: '0 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '14px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto, outline: 'none',
  fontFamily: "'Manrope', sans-serif",
};

const textareaStyle = {
  ...inputStyle, height: 'auto', minHeight: '60px',
  padding: '8px 10px', resize: 'vertical', fontFamily: 'inherit',
};

const emailValido = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || '').trim());

function formatarDataHora(v) {
  if (!v) return '';
  const d = new Date(v);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yy} às ${hh}:${mi}`;
}

function emojiPapel(papel, origem) {
  if (papel === 'vendedor' || origem === 'A') return '💼';
  if (papel === 'responsavel') return '⭐';
  return '';
}

// ─── Ícones SVG dos botões ───────────────────────────────────────────────────
const svgProps = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
const SvgVideo = ({ s = 15 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps} style={{ display: 'block' }}>
    <path d="M23 7l-7 5 7 5V7z" /><rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
  </svg>
);
const SvgLapis = ({ s = 15 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps} style={{ display: 'block' }}>
    <path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
  </svg>
);
const SvgLixeira = ({ s = 15 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps} style={{ display: 'block' }}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);
const SvgProibido = ({ s = 15 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps} style={{ display: 'block' }}>
    <circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
  </svg>
);
const SvgLink = ({ s = 12 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps} style={{ verticalAlign: 'middle', marginRight: '4px' }}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);
const SvgCopiar = ({ s = 12 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps} style={{ verticalAlign: 'middle', marginRight: '4px' }}>
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);
const SvgBandeira = ({ s = 16 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps}>
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" /><line x1="4" y1="22" x2="4" y2="15" />
  </svg>
);
const SvgRelogio = ({ s = 15 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps} style={{ display: 'block' }}>
    <circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" />
  </svg>
);
const SvgPin = ({ s = 16 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...svgProps}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);

// Form vazio
const FORM_VAZIO = {
  assunto: '',
  descricao: '',
  data_inicio: '',
  duracao_min: 30,
  exibir_timeline: true,
  participantes: [],
};

// ═══════════════════════════════════════════════════════════════════════════════
// `dadosLancamento` (opcional): { cliente_id, cliente_label, projeto_id,
// projeto_descricao, tipo_negocio, chamado } — quando informado, mostra o botão
// "Lançar horas", que abre o LancamentoModal já preenchido com esses dados.
function CallsModal({ aberto, negocio, clienteId, usuarioId, fase, dadosLancamento, onFechar, onCallCriada }) {
  const [calls, setCalls]                 = useState([]);
  // Lista de eventos extras (Anotação + outros tipos futuros).
  // Calls ficam em `calls` separado pra preservar a lógica de participantes.
  const [eventosExtras, setEventosExtras] = useState([]);
  const [anotacaoAberto, setAnotacaoAberto] = useState(false);
  // Snapshot dos dados no clique (objeto estável pro LancamentoModal).
  const [lancamentoPreenchido, setLancamentoPreenchido] = useState(null);
  const [carregando, setCarregando]       = useState(false);
  const [mostrarForm, setMostrarForm]     = useState(false);
  const [editandoCall, setEditandoCall]   = useState(null);
  const [form, setForm]                   = useState(FORM_VAZIO);
  const [erro, setErro]                   = useState('');
  const [salvando, setSalvando]           = useState(false);

  // Lista completa de participantes do cliente pra usar nos checkboxes
  const [participantesCliente, setParticipantesCliente] = useState([]);
  // Form inline de novo participante
  const [mostrarNovoPart, setMostrarNovoPart] = useState(false);
  const [formNovoPart, setFormNovoPart]       = useState({ nome: '', email: '' });
  const [erroNovoPart, setErroNovoPart]       = useState('');

  const carregarCalls = useCallback(async () => {
    if (!negocio?.id) return;
    try {
      setCarregando(true);
      // ── 1) Calls (com participantes) ──
      const lista = await negocioCallService.listar(negocio.id, fase);
      const callsComPart = await Promise.all(lista.map(async c => {
        try {
          const parts = await negocioCallService.listarParticipantes(c.id);
          return { ...c, participantes: parts };
        } catch (err) {
          console.error(`[CallsModal] Erro ao carregar participantes da call ${c.id}:`, err);
          return { ...c, participantes: [] };
        }
      }));
      setCalls(callsComPart);

      // ── 2) Outros eventos (Anotação, mudança de etapa, etc.) ──
      // Inclui eventos de "Etapa: ..." na lista pra dar visibilidade total
      // do histórico — eles aparecem em modo somente-leitura (não permite
      // editar/excluir um evento de etapa pela lista; mudanças de etapa
      // são feitas pelo modal "Alterar Etapa").
      try {
        const todos = (fase === 'T')
          ? await timelineTecnicaService.listarTodos(negocio.id)
          : await negocioEventoService.listarTodos(negocio.id);
        // Filtra fora apenas as calls (já carregadas acima como item próprio).
        // Eventos de Etapa: ... (incluindo Etapa Técnica: ...) ficam na lista.
        const extras = (todos || []).filter(e => e.tipo_evento !== 'Call');
        setEventosExtras(extras);
      } catch (errEv) {
        console.error('[CallsModal] Erro ao listar eventos extras:', errEv);
        setEventosExtras([]);
      }
    } catch (err) {
      console.error('[CallsModal] Erro ao listar calls:', err);
      console.error('  URL:', err?.config?.url);
      console.error('  Response:', err?.response?.data);
      setCalls([]);
      setEventosExtras([]);
    } finally {
      setCarregando(false);
    }
  }, [negocio?.id]);

  const carregarParticipantesCliente = useCallback(async () => {
    if (!clienteId) {
      setParticipantesCliente([]);
      return;
    }
    try {
      const lista = await clienteParticipanteService.listarPorCliente(clienteId, negocio?.id);
      setParticipantesCliente(lista);
    } catch (err) {
      console.error('[CallsModal] Erro ao listar participantes do cliente:', err);
      console.error('  URL:', err?.config?.url);
      console.error('  Response:', err?.response?.data);
      setParticipantesCliente([]);
    }
  }, [clienteId, negocio?.id]);

  useEffect(() => {
    if (aberto) {
      carregarCalls();
      carregarParticipantesCliente();
    }
  }, [aberto, carregarCalls, carregarParticipantesCliente]);

  const abrirNova = () => {
    setForm({ ...FORM_VAZIO, participantes: [] });
    setEditandoCall(null);
    setErro('');
    setMostrarForm(true);
  };

  const abrirEdicao = async (call) => {
    // Preenche form com dados da call
    const dataIso = new Date(call.data_inicio).toISOString().slice(0, 16); // pra input datetime-local
    setForm({
      assunto:         call.assunto,
      descricao:       call.descricao || '',
      data_inicio:     dataIso,
      duracao_min:     call.duracao_min,
      exibir_timeline: !!call.exibir_timeline,
      participantes:   (call.participantes || []).map(p => p.id),
    });
    setEditandoCall(call);
    setErro('');
    setMostrarForm(true);
  };

  const cancelarForm = () => {
    setMostrarForm(false);
    setEditandoCall(null);
    setForm(FORM_VAZIO);
    setErro('');
  };

  const toggleParticipante = (pid) => {
    setForm(f => ({
      ...f,
      participantes: f.participantes.includes(pid)
        ? f.participantes.filter(x => x !== pid)
        : [...f.participantes, pid],
    }));
  };

  const adicionarNovoParticipante = async () => {
    setErroNovoPart('');
    if (!formNovoPart.nome.trim())         return setErroNovoPart('Nome é obrigatório.');
    if (!emailValido(formNovoPart.email))  return setErroNovoPart('E-mail inválido.');
    if (!clienteId)  return setErroNovoPart('Cliente não identificado. Feche e reabra o modal.');
    if (!negocio?.id) return setErroNovoPart('Negócio não identificado. Feche e reabra o modal.');

    // Fase 1: chama API pra criar participante
    let idCriado = null;
    try {
      const res = await clienteParticipanteService.incluir(clienteId, {
        nome:  formNovoPart.nome,
        email: formNovoPart.email,
        negocio_id: negocio.id,
      });
      idCriado = res?.id;
    } catch (err) {
      console.error('[CallsModal] Erro ao criar participante:', err);
      console.error('  URL:', err?.config?.url);
      console.error('  Response:', err?.response?.data);
      return setErroNovoPart(
        err.response?.data?.mensagem
        || `Erro ao criar participante (${err?.response?.status || 'sem resposta'}).`
      );
    }

    // Fase 2: recarrega a lista (não bloqueia se falhar)
    try {
      await carregarParticipantesCliente();
    } catch (err) {
      console.error('[CallsModal] Erro ao recarregar lista:', err);
      // Não aborta — o participante já foi criado
    }

    // Fase 3: marca como selecionado na call
    if (idCriado) {
      setForm(f => ({ ...f, participantes: [...f.participantes, idCriado] }));
    }
    setFormNovoPart({ nome: '', email: '' });
    setMostrarNovoPart(false);
  };

  const salvar = async () => {
    setErro('');
    if (!form.assunto.trim())  return setErro('Assunto é obrigatório.');
    if (!form.data_inicio)     return setErro('Data e hora de início são obrigatórias.');
    if (form.participantes.length === 0) return setErro('Selecione pelo menos 1 participante.');
    if (!negocio?.id) return setErro('Negócio não identificado. Feche e reabra o modal.');

    setSalvando(true);
    // Sinaliza se foi criação (pra disparar onCallCriada)
    const ehCriacao = !editandoCall;
    // Fase 1: salva a call
    try {
      // Inclui `fase` no payload se foi passada (ex: 'T' pra fase técnica).
      // Default no backend é 'C' quando não vem (mantém comportamento antigo).
      const payload = { ...form, usuario_id: usuarioId };
      if (fase) payload.fase = fase;
      if (editandoCall) {
        await negocioCallService.alterar(negocio.id, editandoCall.id, payload);
      } else {
        await negocioCallService.criar(negocio.id, payload);
      }
    } catch (err) {
      console.error('[CallsModal] Erro ao salvar call:', err);
      console.error('  URL:', err?.config?.url);
      console.error('  Payload:', err?.config?.data);
      console.error('  Response:', err?.response?.data);
      setSalvando(false);
      return setErro(
        err.response?.data?.mensagem
        || `Erro ao salvar call (${err?.response?.status || 'sem resposta'}).`
      );
    }

    // Fase 2: recarrega a lista (não bloqueia)
    try {
      await carregarCalls();
    } catch (err) {
      console.error('[CallsModal] Erro ao recarregar calls:', err);
    }

    cancelarForm();
    setSalvando(false);

    // Notifica o pai pra que ele possa, por ex., perguntar se avança etapa
    if (ehCriacao && typeof onCallCriada === 'function') {
      try { onCallCriada(); } catch (errCb) { console.error('onCallCriada falhou:', errCb); }
    }
  };

  const cancelarCall = async (call) => {
    if (!window.confirm(`Cancelar a call "${call.assunto}"?\nEla será removida do Teams (quando integrado) e marcada como cancelada.`)) return;
    try {
      await negocioCallService.cancelar(negocio.id, call.id);
      await carregarCalls();
    } catch (err) {
      console.error('[CallsModal] Erro ao cancelar call:', err);
      console.error('  URL:', err?.config?.url);
      console.error('  Response:', err?.response?.data);
      alert(
        err.response?.data?.mensagem
        || `Erro ao cancelar call (${err?.response?.status || 'sem resposta'}).`
      );
    }
  };

  // Confirmação do AnotacaoModal — cria anotação na fase atual.
  // Confirmação do AnotacaoModal — cria anotação na fase atual.
  // Usa o endpoint genérico /api/eventos/.../anotacao que aceita `fase` no body.
  // Default fase='C' (comercial), pra técnica passa 'T'.
  const handleConfirmarAnotacao = async (dados) => {
    await negocioEventoService.criarAnotacao(negocio.id, {
      ...dados,
      fase:       fase || 'C',
      usuario_id: usuarioId,
    });
    setAnotacaoAberto(false);
    await carregarCalls();
  };

  // Excluir evento extra (anotação etc) — funciona pra ambas as fases
  // através do endpoint genérico DELETE /api/eventos/evento/:id
  const excluirEvento = async (evento) => {
    if (!window.confirm(`Excluir esta ${(evento.tipo_evento || '').toLowerCase()}?\nA exclusão é permanente.`)) return;
    try {
      await negocioEventoService.excluirEvento(evento.id);
      await carregarCalls();
    } catch (err) {
      console.error('[CallsModal] Erro ao excluir evento:', err);
      alert(err.response?.data?.mensagem || 'Erro ao excluir evento.');
    }
  };

  const copiarLink = (link) => {
    if (!link) return;
    navigator.clipboard?.writeText(link);
    alert('Link copiado!');
  };

  if (!aberto) return null;

  // Z-index alto porque o Modal principal do negócio pode estar em ~1000.
  // Precisamos ficar acima dele.
  const Z_INDEX_OVERLAY = 10000;
  const Z_INDEX_MODAL   = 10001;

  // ═══════════════════════════════════════════════════════════════════════════
  return (
    <>
      <Modal
        aberto={aberto}
        titulo={`Eventos do Negócio ${negocio?.id || ''}`}
        onFechar={onFechar}
        rotina="crm"
        descricao="Calls, anotações e eventos de acompanhamento do negócio."
        botoesNoTopo
        somenteLeitura
        largura="900px"
      >
        <div style={{ fontFamily: "'Manrope', sans-serif" }}>
          {!mostrarForm && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <button onClick={abrirNova} style={{
                padding: '8px 16px', fontSize: '13px', fontWeight: '600',
                border: `1px solid ${COR.teams}`,
                borderRadius: '5px',
                backgroundColor: '#e0e7ff',
                color: COR.teams,
                cursor: 'pointer',
                display: 'inline-flex', alignItems: 'center', gap: '6px',
              }}>
                <SvgVideo />Agendar nova call
              </button>
              {/* Anotação só aparece na fase técnica (até existir endpoint comercial) */}
              {/* Botão de Anotação aparece em qualquer fase (C ou T) */}
              <button onClick={() => setAnotacaoAberto(true)} style={{
                padding: '8px 16px', fontSize: '13px', fontWeight: '600',
                border: `1px solid ${COR.amarelo}`,
                borderRadius: '5px',
                backgroundColor: COR.amlBg,
                color: COR.amarelo,
                cursor: 'pointer',
                display: 'inline-flex', alignItems: 'center', gap: '6px',
              }}>
                <SvgLapis />Nova anotação
              </button>
              {dadosLancamento && (
                <button onClick={() => setLancamentoPreenchido({ ...dadosLancamento })} style={{
                  padding: '8px 16px', fontSize: '13px', fontWeight: '600',
                  border: `1px solid ${COR.azul}`,
                  borderRadius: '5px',
                  backgroundColor: COR.azulBg,
                  color: COR.azul,
                  cursor: 'pointer',
                  display: 'inline-flex', alignItems: 'center', gap: '6px',
                }}>
                  <SvgRelogio />Lançar horas
                </button>
              )}
            </div>
          )}

          {/* Form de criação/edição */}
          {mostrarForm && (
            <div style={{
              padding: '16px', marginBottom: '16px',
              border: `1px solid ${COR.teams}`, borderRadius: '6px',
              backgroundColor: '#f8f8ff',
            }}>
              <div style={{
                fontSize: '13px', fontWeight: '700', color: COR.teams,
                marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px',
                display: 'flex', alignItems: 'center', gap: '6px',
              }}>
                {editandoCall ? <><SvgLapis s={14} />Editar Call</> : <><SvgVideo s={14} />Nova Call (Teams)</>}
              </div>

              {erro && (
                <div style={{
                  backgroundColor: COR.vermBg, border: `1px solid #ffcccc`,
                  borderRadius: '5px', color: COR.vermelho, fontSize: '12px',
                  padding: '8px 10px', marginBottom: '10px',
                }}>{erro}</div>
              )}

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontSize: '12px', fontWeight: '600', color: COR.muted, display: 'block', marginBottom: '4px' }}>
                  Assunto <span style={{ color: COR.vermelho }}>*</span>
                </label>
                <input value={form.assunto}
                  onChange={e => setForm(f => ({ ...f, assunto: e.target.value }))}
                  style={inputStyle} placeholder="Ex: Alinhamento semanal do projeto"
                  maxLength={200} autoFocus />
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontSize: '12px', fontWeight: '600', color: COR.muted, display: 'block', marginBottom: '4px' }}>
                  Descrição / Complemento
                </label>
                <textarea value={form.descricao}
                  onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))}
                  style={textareaStyle} placeholder="Detalhes enviados no convite..."
                  maxLength={1000} />
              </div>

              <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                <div style={{ flex: 2 }}>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: COR.muted, display: 'block', marginBottom: '4px' }}>
                    Data e hora <span style={{ color: COR.vermelho }}>*</span>
                  </label>
                  <input type="datetime-local" value={form.data_inicio}
                    onChange={e => setForm(f => ({ ...f, data_inicio: e.target.value }))}
                    style={inputStyle} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: COR.muted, display: 'block', marginBottom: '4px' }}>
                    Duração (min)
                  </label>
                  <input type="number" min="5" max="480" value={form.duracao_min}
                    onChange={e => setForm(f => ({ ...f, duracao_min: parseInt(e.target.value) || 30 }))}
                    style={inputStyle} />
                </div>
              </div>

              {/* Checkbox timeline */}
              <label style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                fontSize: '13px', color: COR.texto,
                padding: '8px 12px',
                border: `1px solid ${form.exibir_timeline ? COR.teams : COR.borda}`,
                backgroundColor: form.exibir_timeline ? COR.branco : COR.cinzaBg,
                borderRadius: '5px', userSelect: 'none', cursor: 'pointer',
                marginBottom: '10px',
              }}>
                <input type="checkbox" checked={form.exibir_timeline}
                  onChange={e => setForm(f => ({ ...f, exibir_timeline: e.target.checked }))}
                  style={{ cursor: 'pointer', width: '16px', height: '16px' }} />
                <span style={{ fontWeight: form.exibir_timeline ? '600' : '400' }}>
                  Exibir na timeline do negócio
                </span>
              </label>

              {/* Participantes */}
              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontSize: '12px', fontWeight: '600', color: COR.muted, display: 'block', marginBottom: '6px' }}>
                  Participantes <span style={{ color: COR.vermelho }}>*</span>
                </label>
                <div style={{
                  display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
                  gap: '6px', marginBottom: '8px',
                }}>
                  {participantesCliente.map(p => {
                    const marcado = form.participantes.includes(p.id);
                    const emoji = emojiPapel(p.papel, p.origem);
                    return (
                      <label key={p.id} style={{
                        display: 'flex', alignItems: 'center', gap: '6px',
                        padding: '6px 10px',
                        border: `1px solid ${marcado ? COR.teams : COR.borda}`,
                        borderRadius: '5px',
                        backgroundColor: marcado ? COR.azulBg : COR.branco,
                        cursor: 'pointer', fontSize: '12px',
                      }}>
                        <input type="checkbox" checked={marcado}
                          onChange={() => toggleParticipante(p.id)}
                          style={{ cursor: 'pointer' }} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: '600', color: COR.texto, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {emoji && <span style={{ marginRight: '3px' }}>{emoji}</span>}
                            {p.nome}
                          </div>
                          <div style={{ fontSize: '11px', color: COR.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {p.email}
                          </div>
                        </div>
                      </label>
                    );
                  })}
                  {participantesCliente.length === 0 && (
                    <div style={{ fontSize: '12px', color: COR.muted, padding: '10px' }}>
                      Nenhum participante cadastrado no cliente ainda.
                    </div>
                  )}
                </div>

                {!mostrarNovoPart && (
                  <button onClick={() => setMostrarNovoPart(true)} style={{
                    padding: '5px 10px', fontSize: '11px', fontWeight: '600',
                    border: `1px dashed ${COR.verde}`, borderRadius: '5px',
                    backgroundColor: 'transparent', color: COR.verde,
                    cursor: 'pointer',
                  }}>+ Novo participante</button>
                )}

                {mostrarNovoPart && (
                  <div style={{
                    padding: '10px', border: `1px solid ${COR.verde}`,
                    borderRadius: '5px', backgroundColor: COR.verdeBg,
                  }}>
                    {erroNovoPart && (
                      <div style={{ fontSize: '12px', color: COR.vermelho, marginBottom: '6px' }}>
                        {erroNovoPart}
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                      <input placeholder="Nome completo" value={formNovoPart.nome}
                        onChange={e => setFormNovoPart(p => ({ ...p, nome: e.target.value }))}
                        style={{ ...inputStyle, flex: 1 }} maxLength={100} />
                      <input type="email" placeholder="email@cliente.com" value={formNovoPart.email}
                        onChange={e => setFormNovoPart(p => ({ ...p, email: e.target.value }))}
                        style={{ ...inputStyle, flex: 1 }} maxLength={100} />
                    </div>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={adicionarNovoParticipante} style={{
                        padding: '5px 12px', fontSize: '12px', fontWeight: '600',
                        border: 'none', borderRadius: '5px',
                        backgroundColor: COR.verde, color: COR.branco, cursor: 'pointer',
                      }}>Adicionar</button>
                      <button onClick={() => { setMostrarNovoPart(false); setFormNovoPart({nome:'',email:''}); setErroNovoPart(''); }} style={{
                        padding: '5px 12px', fontSize: '12px',
                        border: `1px solid ${COR.borda}`, borderRadius: '5px',
                        backgroundColor: COR.branco, cursor: 'pointer',
                      }}>Cancelar</button>
                    </div>
                  </div>
                )}
              </div>

              {/* Botões do form */}
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button onClick={salvar} disabled={salvando} style={{
                  padding: '8px 16px', fontSize: '12px', fontWeight: '600',
                  border: 'none', borderRadius: '5px',
                  backgroundColor: COR.teams, color: COR.branco,
                  cursor: salvando ? 'not-allowed' : 'pointer',
                  opacity: salvando ? 0.6 : 1,
                }}>{salvando ? 'Salvando...' : (editandoCall ? 'Salvar alterações' : 'Criar call')}</button>
                <button onClick={cancelarForm} disabled={salvando} style={{
                  padding: '8px 16px', fontSize: '12px',
                  border: `1px solid ${COR.borda}`, borderRadius: '5px',
                  backgroundColor: COR.branco, cursor: 'pointer',
                }}>Cancelar</button>
              </div>
            </div>
          )}

          {/* Lista de calls existentes */}
          <div style={{ fontSize: '11px', fontWeight: '700', color: COR.muted, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>
            Calls agendadas
          </div>

          {carregando ? (
            <div style={{ padding: '20px', textAlign: 'center', color: COR.muted, fontSize: '13px' }}>
              Carregando...
            </div>
          ) : (calls.length === 0 && eventosExtras.length === 0) ? (
            <div style={{
              padding: '20px', textAlign: 'center',
              fontSize: '12px', color: COR.muted,
              border: `1px dashed ${COR.borda}`, borderRadius: '6px',
            }}>
              Nenhum evento registrado ainda.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {/* ── Calls ── */}
              {calls.map(c => (
                <div key={`call-${c.id}`} style={{
                  border: `1px solid ${COR.borda}`,
                  borderLeft: `4px solid ${COR.teams}`,
                  borderRadius: '6px',
                  padding: '12px 14px', backgroundColor: COR.cinzaBg,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                    <span style={{ color: COR.teams, display: 'inline-flex', alignItems: 'center' }}><SvgVideo s={18} /></span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: COR.texto }}>
                        {c.assunto}
                      </div>
                      <div style={{ fontSize: '11px', color: COR.muted }}>
                        {formatarDataHora(c.data_inicio)} · {c.duracao_min} min
                      </div>
                    </div>
                    <button onClick={() => abrirEdicao(c)} title="Editar" style={{
                      border: 'none', background: 'transparent',
                      color: COR.azul, cursor: 'pointer', fontSize: '14px', padding: '4px 8px',
                    }}><SvgLapis /></button>
                    <button onClick={() => cancelarCall(c)} title="Cancelar" style={{
                      border: 'none', background: 'transparent',
                      color: COR.vermelho, cursor: 'pointer', fontSize: '14px', padding: '4px 8px',
                    }}><SvgProibido /></button>
                  </div>

                  {c.descricao && (
                    <div style={{ fontSize: '12px', color: COR.muted, marginBottom: '6px', paddingLeft: '28px' }}>
                      {c.descricao}
                    </div>
                  )}

                  {c.participantes && c.participantes.length > 0 && (
                    <div style={{ paddingLeft: '28px', marginBottom: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                      {c.participantes.map(p => (
                        <span key={p.id} style={{
                          fontSize: '11px', padding: '2px 8px',
                          backgroundColor: COR.branco,
                          border: `1px solid ${COR.borda}`,
                          borderRadius: '12px', color: COR.texto,
                        }}>
                          {p.origem === 'A' ? '💼 ' : ''}{p.nome}
                        </span>
                      ))}
                    </div>
                  )}

                  {c.link_teams && (
                    <div style={{ paddingLeft: '28px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <a href={c.link_teams} target="_blank" rel="noopener noreferrer" style={{
                        fontSize: '11px', color: COR.teams, fontWeight: '600',
                        textDecoration: 'none',
                      }}>
                        <SvgLink />Abrir no Teams
                      </a>
                      <button onClick={() => copiarLink(c.link_teams)} title="Copiar link" style={{
                        border: 'none', background: 'transparent', cursor: 'pointer',
                        fontSize: '11px', color: COR.muted,
                      }}><SvgCopiar />copiar</button>
                    </div>
                  )}
                </div>
              ))}

              {/* ── Eventos extras (Anotação, mudança de Etapa, etc.) ── */}
              {eventosExtras.map(ev => {
                const ehAnotacao = ev.tipo_evento === 'Anotação';
                const ehEtapa    = (ev.tipo_evento || '').startsWith('Etapa:') ||
                                   (ev.tipo_evento || '').startsWith('Etapa Técnica:');
                const cor   = ehEtapa    ? COR.azul
                            : ehAnotacao ? COR.amarelo
                            : COR.muted;
                const corBg = ehEtapa    ? COR.azulBg
                            : ehAnotacao ? COR.amlBg
                            : COR.cinzaBg;
                const icone = ehEtapa    ? <SvgBandeira s={18} />
                            : ehAnotacao ? <SvgLapis s={18} />
                            : <SvgPin s={18} />;
                return (
                  <div key={`ev-${ev.id}`} style={{
                    border: `1px solid ${COR.borda}`,
                    borderLeft: `4px solid ${cor}`,
                    borderRadius: '6px',
                    padding: '12px 14px', backgroundColor: corBg,
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                      <span style={{ color: cor, display: 'inline-flex', alignItems: 'center' }}>{icone}</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: COR.texto }}>
                          {ev.tipo_evento}
                        </div>
                        <div style={{ fontSize: '11px', color: COR.muted }}>
                          {formatarDataHora(ev.data_evento)}
                          {ev.autor_nome ? ` · por ${ev.autor_nome}` : ''}
                          {!ev.exibir_timeline && !ehEtapa && (
                            <span style={{ marginLeft: '6px', fontStyle: 'italic' }}>
                              · oculto da timeline
                            </span>
                          )}
                        </div>
                      </div>
                      {/* Eventos de Etapa são read-only — não mostra botão excluir.
                          Mudanças de etapa devem ser feitas pelo modal "Alterar Etapa". */}
                      {!ehEtapa && (
                        <button onClick={() => excluirEvento(ev)} title="Excluir" style={{
                          border: 'none', background: 'transparent',
                          color: COR.vermelho, cursor: 'pointer', fontSize: '14px', padding: '4px 8px',
                        }}><SvgLixeira /></button>
                      )}
                    </div>
                    {ev.descricao && (
                      <div style={{
                        fontSize: '12px', color: COR.texto, paddingLeft: '28px',
                        whiteSpace: 'pre-wrap',
                      }}>
                        {ev.descricao}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Modal>

      {/* Sub-modal de Anotação (renderizado acima do CallsModal) */}
      <AnotacaoModal
        aberto={anotacaoAberto}
        onCancelar={() => setAnotacaoAberto(false)}
        onConfirmar={handleConfirmarAnotacao}
      />

      {/* Lançamento de horas pré-preenchido com os dados do negócio */}
      {lancamentoPreenchido && (
        <LancamentoModal
          preenchido={lancamentoPreenchido}
          onFechar={() => setLancamentoPreenchido(null)}
        />
      )}
    </>
  );
}

export default CallsModal;
